module.exports = __webpack_public_path__ + "static/media/kuchnia-2-min.aa6c8e2a.png";